import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  width: 100%;

  @media ${({ theme }) => theme.device.mobile} {
    padding: 0 16px 0 16px;
    margin-top: 16px;
  }
`;

export const ButtonAddContainer = styled.div`
  bottom: 0;
  right: 0;
  height: 104px;
  width: 104px;
  flex: 1;
  display: flex;
  flex-direction: column-reverse;
  align-self: flex-end;

  > button {
    cursor: pointer;
    background: ${ColorPalette.Transparent};
  }
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
